import { Button, useDisclosure } from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import ConfirmationDialog from 'components/dialogs/ConfirmationDialog';
import { LockIcon } from 'components/icons';
import React, { FC } from 'react';
import { graphql, useMutation } from 'utils/graphClient';
import { CloseFormControl_closeForm_Mutation } from './__generated__/CloseFormControl_closeForm_Mutation.graphql';

const closeFormMutation = graphql`
  mutation CloseFormControl_closeForm_Mutation($formId: ID!) {
    closeForm(input: { id: $formId }) {
      form {
        id
        isClosed
      }
    }
  }
`;

interface CloseFormControlProps {
  formId: string;
}

export const CloseFormControl: FC<CloseFormControlProps> = ({ formId }) => {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const [closeForm, isLoading] =
    useMutation<CloseFormControl_closeForm_Mutation>(closeFormMutation);

  return (
    <>
      <Button
        colorScheme="blue"
        leftIcon={<LockIcon />}
        onClick={onOpen}
      >{t`Close form`}</Button>
      <ConfirmationDialog
        action={{
          name: t`Close form`,
          onAction: () => closeForm({ variables: { formId } }),
          inProgress: isLoading,
        }}
        isOpen={isOpen}
        onClose={onClose}
      >
        {t`Are you sure you want to close this form? Members will no longer be able to respond. You can't undo this action.`}
      </ConfirmationDialog>
    </>
  );
};
